export var ACTION_NAME;
(function (ACTION_NAME) {
    ACTION_NAME["SET_SCROLL_RANDOM"] = "SET_SCROLL_RANDOM";
})(ACTION_NAME || (ACTION_NAME = {}));
const initialState = {
    mathRandom: 0,
};
export const scrollRandomReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_NAME.SET_SCROLL_RANDOM:
            return { ...state, mathRandom: action.mathRandom };
        default:
            return state;
    }
};
